function initialState() {
  return {
    FormPreviewModalInfo: {
      showModal: false,
      formId: null
    },
    AddFormsToPacketModalInfo: {
      showModal: false,
      packetInfo: null
    },
    FormCloneSelection: {},
    SelectedFormStore: null,
    SaveAsConfirmationModalInfo: {
      showModal: false,
      data: null
    },
    CopyIndividualFormModalInfo:{
      showModal : false,
      data : null
    },
    CopyMultipleFormsModalInfo:{
      showModal : false,
      data: null
    }
  };
}

const state = initialState();

const actions = {
  updateFormPreviewModalInfo(context, data) {
    context.commit("updateFormPreviewModalInfo", data);
  },
  getForms: function(context, payload) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "post",
        "/api/form/search",
        payload
      )
        .then(response => {
          if (response && response.data && response.data.data)
            resolve(response.data.data);
          else reject(response);
        })
        .catch(error => reject(error));
    });
  },
  getPackets: function(context, payload) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "post",
        "/api/packet/search",
        payload
      )
        .then(response => {
          if (response && response.data && response.data.data)
            resolve(response.data.data);
          else reject(response);
        })
        .catch(error => reject(error));
    });
  },
  async getPacketDetails(context, packetId) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "get",
      "/api/packet/" + packetId
    );
    return response && response.data ? response.data.data : null;
  },
  async savePacketDetails(context, packetInfo) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/api/packet",
      packetInfo
    );
    return response && response.data ? response.data.data : null;
  },
  updateAddFormsToPacketModal: function(context, data) {
    context.commit("updateAddFormsToPacketModal", data);
  },
  updateFormCloneSelection: function(context, data) {
    context.commit("updateFormCloneSelection", data);
  },
  updateSelectedFormStore: function(context, data) {
    context.commit("updateSelectedFormStore", data);
  },
  async getFormsToAdd(context, request) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/api/form/search",
      request
    );
    return response && response.data ? response.data.data : null;
  },
  async addFormsToPacket(context, data) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/api/packet/add_forms_to_packet",
      data
    );
    return response && response.data ? response.data.data : null;
  },
  removeFormsFromPacket: function(context, data) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "post",
        "/api/packet/remove_forms_from_packet",
        data
      )
        .then(resp => {
          if (resp && resp.data && resp.data.data) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  async cloneForm(context, data) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/api/form/clone",
      data
    ).catch(err => err.response);
    return response && response.data && response.data.successful ? response.data.data : null;
  },

  updateSaveAsConfirmationModal: function(context, data) {
    context.commit("updateSaveAsConfirmationModal", data);
  },
  updateCopyIndividualFormModalInfo(context, data){
    context.commit("updateCopyIndividualFormModalInfo", data);
  },
  updateCopyMultipleFormsModalInfo(context, data){
    context.commit("updateCopyMultipleFormsModalInfo", data);
  },
  async copyDealerForm(context, payload){
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/api/form/copyDealerForm/queueRequest",
      payload
    ).catch(err => err.response);
    return response && response.data && response.data.successful ? response.data.data : null;
  }
};

const mutations = {
  updateFormPreviewModalInfo(state, data) {
    state.FormPreviewModalInfo = data;
  },
  updateAddFormsToPacketModal: function(state, data) {
    state.AddFormsToPacketModalInfo = data;
  },
  updateFormCloneSelection: function(state, data) {
    state.FormCloneSelection = data;
  },
  updateSelectedFormStore: function(state, data) {
    state.SelectedFormStore = data;
  },
  updateSaveAsConfirmationModal: function(state, data) {
    state.SaveAsConfirmationModalInfo = data;
  },
  updateCopyIndividualFormModalInfo(state, data){
    state.CopyIndividualFormModalInfo = data;
  },
  updateCopyMultipleFormsModalInfo(state, data){
    state.CopyMultipleFormsModalInfo = data;
  },
};

const getters = {
  FormCloneSelection: function(state) {
    return state.FormCloneSelection;
  },
  SelectedFormStore: function(state) {
    return state.SelectedFormStore;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/Forms.js